import styled from 'styled-components'
import { Card as DdsCard, getFontStyle } from '@diversioteam/diversio-ds'

export const Card = styled(DdsCard)`
    flex: 1;

    &.dds-card {
        align-items: center;
        padding: 48px;
    }
`

export const Title = styled.h2`
    margin: 24px 0 12px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('cardHeaderBold')};
`

export const Description = styled.p`
    max-width: 500px;
    margin: 12px 0 24px;
    text-align: center;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p02Regular')};
`
